import { gql, useQuery } from '@apollo/client'

import type { Outcome } from '@/lib/apollo/model/outcome'
import type { WrappedUseQuery } from '@/lib/apollo/types'

const applicationOutcomeQuery = gql`
  query (
    $customerId: String!
    $applicationId: String!
    $subjectId: String!
    $isReport: Boolean!
  ) {
    getDashboardApplication(
      customerId: $customerId
      applicationId: $applicationId
      subjectId: $subjectId
      isReport: $isReport
    ) {
      outcome {
        sections {
          name
          status
          properties {
            name
            status
          }
        }
      }
    }
  }
`

export type ApplicationOutcomeQueryOutcome = Pick<Outcome, 'sections'>

export type ApplicationOutcomeData = {
  getDashboardApplication: {
    outcome: ApplicationOutcomeQueryOutcome | null
  }
}

type QueryVars = {
  customerId: string
  applicationId: string
  subjectId: string
  isReport: boolean
}

export const useApplicationOutcomeQuery: WrappedUseQuery<
  ApplicationOutcomeData,
  QueryVars
> = options =>
  useQuery<ApplicationOutcomeData, QueryVars>(applicationOutcomeQuery, options)
